import * as React from 'react'

const TvChannelsContext = React.createContext({})

export { TvChannelsContext }

export const useTvChannelsContext = () => React.useContext(TvChannelsContext)